import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  EmailContentConfigRequest,
  EmailContentConfigResponse,
  EmailContentSendRequest,
  EmailContentSendResponse,
} from '../content/email_content_pb';

import {
  EmailContent as __EmailContent,
} from '../content/email_content_pb_service';

@Injectable({providedIn: 'root'})
export class EmailContent {

  constructor(private _ngZone: NgZone) {
  }

  /**
    / Send a piece of content as an email
  */
  send(request: EmailContentSendRequest): Promise<EmailContentSendResponse>;
  /**
    / Send a piece of content as an email
  */
  send(request: EmailContentSendRequest, metadata: grpc.Metadata): Promise<EmailContentSendResponse>;
  /**
    / Send a piece of content as an email
  */
  send(request: EmailContentSendRequest, callback: (err: any|null, response: EmailContentSendResponse, metadata: grpc.Metadata) => void): void;
  /**
    / Send a piece of content as an email
  */
  send(request: EmailContentSendRequest, metadata: grpc.Metadata, callback: (err: any|null, response: EmailContentSendResponse, metadata: grpc.Metadata) => void): void;

  send(request: EmailContentSendRequest, arg1?: grpc.Metadata|((err: any|null, response: EmailContentSendResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: EmailContentSendResponse, metadata: grpc.Metadata) => void): Promise<EmailContentSendResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<EmailContentSendResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__EmailContent.Send, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  /**
    / Gets the current config for email content
  */
  config(request: EmailContentConfigRequest): Promise<EmailContentConfigResponse>;
  /**
    / Gets the current config for email content
  */
  config(request: EmailContentConfigRequest, metadata: grpc.Metadata): Promise<EmailContentConfigResponse>;
  /**
    / Gets the current config for email content
  */
  config(request: EmailContentConfigRequest, callback: (err: any|null, response: EmailContentConfigResponse, metadata: grpc.Metadata) => void): void;
  /**
    / Gets the current config for email content
  */
  config(request: EmailContentConfigRequest, metadata: grpc.Metadata, callback: (err: any|null, response: EmailContentConfigResponse, metadata: grpc.Metadata) => void): void;

  config(request: EmailContentConfigRequest, arg1?: grpc.Metadata|((err: any|null, response: EmailContentConfigResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: EmailContentConfigResponse, metadata: grpc.Metadata) => void): Promise<EmailContentConfigResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<EmailContentConfigResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__EmailContent.Config, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

